import store from '../../store';
import getFullTable from './getFullTable';
const defaultOptions = {
    preferFullTable: true
};
/** Returns the list of data rows already in Store. Does not fetch data from remote server */
export default function getRecords(entity, options) {
    options = Object.assign(Object.assign({}, defaultOptions), options);
    const state = store.state[entity] || {};
    const fullTable = getFullTable(entity);
    const list = state.list || [];
    let result = [];
    if (options === null || options === void 0 ? void 0 : options.preferFullTable) {
        if (fullTable.length > 0) {
            result = fullTable;
        }
        else {
            result = list;
        }
    }
    else {
        result = list;
    }
    return result;
}
